import * as React from "react"
import { Menu, X } from "react-feather"
import {
  Container,
  Flex,
  FlexList,
  Space,
  NavLink,
  InteractiveIcon,
  Nudge,
  VisuallyHidden,
  Text,
} from "./ui"
import {
  mobileNavOverlay,
  mobileNavLink,
  desktopHeaderNavWrapper,
  desktopHeaderNavItemContainer,
  desktopHeaderNavItem,
  mobileHeaderNavWrapper,
  mobileNavSVGColorWrapper,
} from "./header.css"
import NavItemGroup from "./nav-item-group"
import { StaticImage } from "gatsby-plugin-image"
import { theme } from "../theme.css"
import { boxShadow } from "../basic/box-shadow.css"
import {
  navigationData,
  NavItem,
  NavItemGroup as NavItemGroupType,
} from "../data/navigation"

export default function Header() {
  const { navItems } = navigationData
  const [isMobileMenuOpen, setMobileMenuOpen] = React.useState(false)

  const closeMobileMenu = React.useCallback(() => {
    setMobileMenuOpen(false)
  }, [])

  const renderMobileNavItem = (navItem: NavItem | NavItemGroupType) => {
    if (navItem.navItemType === "Link") {
      return (
        <li key={navItem.id} className={mobileNavLink}>
          <NavLink
            style={{ color: "white" }}
            to={navItem.href}
            onClick={closeMobileMenu}
          >
            {navItem.text}
          </NavLink>
        </li>
      )
    } else if (navItem.navItemType === "Group") {
      return (
        <li key={navItem.id} className={mobileNavLink}>
          <NavItemGroup
            key={navItem.id}
            name={navItem.name}
            navItems={navItem.navItems}
            onLinkClick={closeMobileMenu}
          />
        </li>
      )
    }
  }

  return (
    <header className={boxShadow}>
      <Container
        className={desktopHeaderNavWrapper}
        width="fullbleed"
        style={{ backgroundColor: theme.colors.primary }}
      >
        <Space size={2} />
        <Flex variant="center">
          <NavLink to="/">
            <StaticImage
              style={{ border: "1px solid black" }}
              src="../images/FCO_header.jpg"
              alt=""
            />
          </NavLink>
        </Flex>
        <Flex variant="center">
          <NavLink to="/">
            <VisuallyHidden>Home</VisuallyHidden>
          </NavLink>
          <Flex style={{ backgroundColor: theme.colors.primary }}>
            <nav>
              <FlexList gap={4}>
                {navItems?.map((navItem: NavItem | NavItemGroupType) => (
                  <div
                    className={desktopHeaderNavItemContainer}
                    key={navItem.id}
                  >
                    {navItem.navItemType === "Group" && (
                      <NavItemGroup
                        name={navItem.name}
                        navItems={navItem.navItems}
                        onLinkClick={closeMobileMenu}
                      />
                    )}
                    {navItem.navItemType === "Link" && (
                      <NavLink
                        className={desktopHeaderNavItem}
                        to={navItem.href}
                        onClick={closeMobileMenu}
                      >
                        {navItem.text}
                      </NavLink>
                    )}
                  </div>
                ))}
              </FlexList>
            </nav>
          </Flex>
        </Flex>
      </Container>
      <Container
        className={mobileHeaderNavWrapper[isMobileMenuOpen ? "open" : "closed"]}
      >
        <Space size={2} />
        <Flex variant="spaceBetween">
          <span
            className={
              mobileNavSVGColorWrapper[isMobileMenuOpen ? "reversed" : "primary"]
            }
          >
            <NavLink to="/" onClick={closeMobileMenu}>
              <Flex>
                <VisuallyHidden>Home</VisuallyHidden>
                <StaticImage
                  src="../images/header-fco-logo.png"
                  width={60}
                  alt=""
                />
                <Text
                  style={{ textTransform: "initial" }}
                  className={
                    mobileNavSVGColorWrapper[isMobileMenuOpen ? "reversed" : "black"]
                  }
                  variant="medium"
                >
                  FC Ottenhöfen
                </Text>
              </Flex>
            </NavLink>
          </span>
          <Flex>
            <Nudge right={3}>
              <InteractiveIcon
                title="Toggle menu"
                onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                className={
                  mobileNavSVGColorWrapper[isMobileMenuOpen ? "reversed" : "primary"]
                }
              >
                {isMobileMenuOpen ? <X /> : <Menu />}
              </InteractiveIcon>
            </Nudge>
          </Flex>
        </Flex>
      </Container>
      {isMobileMenuOpen && (
        <div className={mobileNavOverlay}>
          <nav>
            <FlexList responsive variant="stretch">
              {navItems?.map((navItem) => renderMobileNavItem(navItem))}
            </FlexList>
          </nav>
        </div>
      )}
    </header>
  )
}
